"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styles_1 = require("@material-ui/core/styles");
const package_1 = require("../package");
const styles = (theme) => (0, styles_1.createStyles)({
    shieldIcon: {
        paddingLeft: theme.spacing(0.5)
    }
});
const shieldIcon = ({ size = 17, style, classes }) => ((0, jsx_runtime_1.jsx)("img", { src: package_1.assets.internalAssets.shieldIcon, className: classes.shieldIcon, style: Object.assign(Object.assign({}, style), { height: size }) }));
exports.default = (0, styles_1.withStyles)(styles)(shieldIcon);
//# sourceMappingURL=ShieldIcon.js.map